import TextField from "@material-ui/core/TextField";
import { IMaskMixin } from "react-imask";

export const MaskedInput = IMaskMixin(({ ...props }) => <TextField {...props} />);
